import * as React from "react";
import { Button } from "../../components/atoms/Button";
import { Portal } from "../../components/atoms/Portal";

class PopupConfirm extends React.Component<{
    onClose?: () => void;
    onClick?: () => void;
    title?: string;
}> {
    public buttonRef = React.createRef<HTMLButtonElement>();
    public componentDidMount(): void {
        setTimeout(() => this.buttonRef.current?.focus(), 50);
    }
    public render(): React.ReactElement {
        const { onClose, onClick, title } = this.props;
        return (
            <Portal>
                <div className="popup_confirm_grayback" onClick={onClose} />
                <div className="popup_confirm_box" data-at_id="popup_confirm_box">
                    <div className="button_container">
                        <div className="popup_confirm_title">{title}</div>
                        <Button
                            onBlur={() => {
                                this.buttonRef.current?.focus();
                            }}
                            innerRef={this.buttonRef}
                            title="OK"
                            data-at_id="popup_confirm_ok"
                            onClick={onClick}
                        />
                        <Button
                            onBlur={() => {
                                this.buttonRef.current?.focus();
                            }}
                            innerRef={this.buttonRef}
                            title="Cancel"
                            onClick={onClose}
                            outlined
                        />
                    </div>
                </div>
            </Portal>
        );
    }
}

export { PopupConfirm };
